var map = {
	"./bg.jpg": 3653,
	"./保定电力_圆形.png": 4712,
	"./张家口职业技术学院_圆形.png": 6575,
	"./河北大学.png": 7706,
	"./河北工业大学.png": 8462,
	"./河北工业职业技术大学_圆形.png": 325,
	"./河北工程技术学院_圆形.png": 4101,
	"./河北师范大学_圆形.png": 13,
	"./河北科技大学_圆形.png": 9017,
	"./河北经贸大学_圆形.png": 7532,
	"./河北软件职业技术学院_圆形.png": 2518,
	"./燕山大学.png": 3738,
	"./石家庄学院_圆形.png": 2290,
	"./石家庄职业技术学院_圆形.png": 9895,
	"./石家庄财经职业学院_圆形.png": 3850
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8000;